import {Component, EventEmitter, Input, Output} from '@angular/core';
import {InspectionModel} from "../../../models/inspection.model";


@Component({
    selector: 'app-inspection-list',
    templateUrl: './inspection-list.component.html',
    styleUrl: './inspection-list.component.scss'
})
export class InspectionListComponent {
    @Input() set inspections(value: InspectionModel[]) {
        if (value) {
            this._allInspections = value;
            this.visibleCount = Math.min(this.initialVisibleCount, this._allInspections.length);
            this.updateVisibleInspections();
        }
    }

    @Output() editInspection = new EventEmitter<InspectionModel>();

    private _allInspections: InspectionModel[] = [];
    visibleInspections: InspectionModel[] = [];
    visibleCount = 0;
    readonly initialVisibleCount = 3;
    readonly incrementCount = 3;

    /**
     * Returns true if there are more inspections to display
     */
    get hasMoreInspections(): boolean {
        return this.visibleCount < this._allInspections.length;
    }

    /**
     * Increases the number of visible inspections
     */
    showMore(): void {
        this.visibleCount = Math.min(
            this.visibleCount + this.incrementCount,
            this._allInspections.length
        );
        this.updateVisibleInspections();
    }

    /**
     * Updates the array of visible inspections
     */
    private updateVisibleInspections(): void {
        this.visibleInspections = this._allInspections.slice(0, this.visibleCount);
    }

    /**
     * Handles edit button click from inspection item
     */
    onEditInspection(inspection: InspectionModel): void {
        this.editInspection.emit(inspection);
    }
}
